import { Stack } from "@mui/material";
import { ICAPMetrics } from "../types";
import Panel from "../components/Panel";
import Gauge from "../components/Gauge";
import StatTile from "../components/StatTile";
import { relativeTime } from "../components/format";

export default function ICAPPanel({ m }: { m: ICAPMetrics }) {
    const total = m.resp200 + m.resp204;
    const modifyPct = total > 0 ? Math.round((m.resp200 / total) * 100) : 0;
    return (
        <Panel title="ICAP connections">
            <Stack direction="row" gap={3} flexWrap="wrap" sx={{ mb: 2 }}>
                <Gauge label="Active connections" value={m.activeConnections} max={m.maxConnections} at={m.peakActiveAt} />
                <Gauge label="Queue" value={m.queueDepth} max={m.queueCapacity} at={m.peakQueueAt} />
            </Stack>
            <Stack direction="row" gap={1} flexWrap="wrap">
                <StatTile label="Accepted" value={m.totalAccepted.toLocaleString()} />
                <StatTile label="Rejected (503)" value={m.totalRejected.toLocaleString()} hint="overload" />
                <StatTile label="Peak active" value={m.peakActive} hint={relativeTime(m.peakActiveAt)} />
                <StatTile label="200 modified" value={m.resp200.toLocaleString()} />
                <StatTile label="204 no-mod" value={m.resp204.toLocaleString()} />
                <StatTile label="Modify ratio" value={`${modifyPct}%`} hint={`${total.toLocaleString()} responses`} />
            </Stack>
        </Panel>
    );
}
